module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loadComments) ? _c('div', {
    staticClass: "comments"
  }, [_c('div', {
    staticClass: "sub_line"
  }, [(_vm.type === 'recommend') ? _c('span', [_vm._v("Komentar Populer")]) : _c('span', [_vm._v("Komentar Terbaru")])]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "comment_list"
    }
  }, _vm._l((_vm.comments), function(com) {
    return _c('li', [_c('img', {
      staticClass: "avatar",
      attrs: {
        "alt": "avatar",
        "src": _vm.getImgSrc(com.user.avatar),
        "onerror": "javascript:this.src='https://img1.dongqiudi.com/fastdfs1/M00/3B/EF/o4YBAFjM9lqAel9GAAAQrsgeQ3A103.jpg'"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "user_info"
    }, [_c('p', {
      staticClass: "name"
    }, [_c('span', [_vm._v(_vm._s(com.user.username))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((com.user.medal_id != 0)),
        expression: "(com.user.medal_id!=0)"
      }],
      staticClass: "icon_v"
    }), _vm._v(" "), (com.user.team_icon) ? _c('span', {
      staticClass: "icon_team",
      style: ({
        backgroundImage: 'url(' + _vm.getImgSrc(com.user.team_icon) + ')'
      })
    }) : _vm._e(), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (com.user.is_root),
        expression: "com.user.is_root"
      }],
      staticClass: "icon_author"
    }, [_vm._v("penulis")])]), _vm._v(" "), _c('p', {
      staticClass: "commend"
    }, [_vm._v("\n                    " + _vm._s(com.up) + "\n                    "), _c('span', {
      class: {
        hot: _vm.type === 'recommend'
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm.formatDate(com.created_at)))]), _vm._v(" "), (com.quote) ? _c('div', {
      staticClass: "quote"
    }, [_c('div', {
      staticClass: "quote_author"
    }, [_c('span', [_vm._v(_vm._s(com.quote.user.username))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((com.quote.user.medal_id != 0)),
        expression: "(com.quote.user.medal_id!=0)"
      }],
      staticClass: "icon_v"
    }), _vm._v(" "), (com.quote.user.team_icon) ? _c('span', {
      staticClass: "icon_team",
      style: ({
        backgroundImage: 'url(' + _vm.getImgSrc(com.quote.user.team_icon) + ')'
      })
    }) : _vm._e(), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (com.quote.user.is_root),
        expression: "com.quote.user.is_root"
      }],
      staticClass: "icon_author"
    }, [_vm._v("penulis")])]), _vm._v(" "), _c('p', {
      staticClass: "quote_con",
      domProps: {
        "innerHTML": _vm._s(com.quote.content)
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "detail"
    }, [_c('p', {
      staticClass: "text_con",
      domProps: {
        "innerHTML": _vm._s(com.content)
      }
    }), _vm._v(" "), ((_vm.imgMode = 'on')) ? _c('div', {
      staticClass: "pic_con"
    }, _vm._l((com.attachments), function(pic) {
      return _c('div', {
        staticClass: "img_con",
        class: (com.attachments_total > 1) ? 'multiple' : 'single'
      }, [_c('img', {
        attrs: {
          "src": _vm.getImgSrc(pic.thumb)
        }
      }), _vm._v(" "), (pic.mime === 'image/gif') ? [_c('div', {
        staticClass: "media-holder"
      }), _vm._v(" "), _c('div', {
        staticClass: "media-label"
      })] : _vm._e()], 2)
    })) : _c('div', [_vm._v("\n                    [images]\n                ")])])])
  })), _vm._v(" "), (_vm.isInApp) ? _c('div', {
    staticClass: "more_comment"
  }, [(_vm.comments.length > 0) ? _c('a', {
    attrs: {
      "href": 'allfootball:///comment/' + _vm.article_id
    }
  }, [_c('img', {
    staticClass: "message-icon",
    attrs: {
      "src": require("../assets/icon_message.jpg"),
      "alt": ""
    }
  }), _vm._v(_vm._s(_vm.$t('readMore')) + " >\n        ")]) : _c('a', {
    staticClass: "no_comment",
    attrs: {
      "href": 'allfootball:///post_comments/' + _vm.article_id
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('noCommented')) + "\n        ")])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-205e60a8","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/comments.vue
// module id = 625
// module chunks = 4 7